import React, { FunctionComponent, useEffect, useState } from 'react'
import { Auth0Provider, User as Auth0User, useAuth0 } from "@auth0/auth0-react";

interface User {
  email?: string;
  name?: string;
  picture?: string;
}

interface Claims {
  "https://hasura.io/jwt/claims"?: {
    "x-hasura-allowed-roles"?: Array<string>;
  }
}

interface Auth {
  isAuthenticated: boolean;
  isLoading: boolean;
  login: () => any;
  logout: () => any;
  token: string | null;
  user?: User & Claims;
}

const Provider:FunctionComponent = ({children}) => {
  return <Auth0Provider
    audience='https://elm-api.com'
    domain="elm-studio.au.auth0.com"
    clientId="aGfrJvdt6wr4WgCmstoTkLJGJHRLDAPJ"
    issuer='https://elm-studio.au.auth0.com/'
    redirectUri={window.location.origin}
  >
    {children}
  </Auth0Provider>
}

export function useAuth() {
  const auth0 = useAuth0<Auth0User & Claims>();

  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    auth0.getAccessTokenSilently()
      .then(setToken)
      .catch(err => console.log('Not logged in'));
  }, []);

  const auth: Auth = {
    isAuthenticated: auth0.isAuthenticated,
    isLoading: auth0.isLoading,
    login: auth0.loginWithRedirect,
    logout: auth0.logout,
    token,
    user: auth0.user
  };

  return auth;
}

export default Provider;
